<template>
  <o-button
    :variant="_model ? 'success' : null"
    :outline="!_model"
    :icon="_model ? 'check' : null"
    :disabled="disabled"
    :name="name"
    @click="_model = !_model"
  >
    {{ label || name || _model }}
  </o-button>
</template>

<script setup lang="ts">
import { getCurrentInstance } from 'vue'

interface Props {
  modelValue?: string | Record<string, any> | number | boolean | any[] | null
  disabled?: boolean
  name?: string | null
  label?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  disabled: false,
  name: null,
  label: null,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void
}>()

const id = getCurrentInstance()?.uid

const _model = computed({
  get () {
    return props.modelValue
  },
  set (model: any) {
    emit('update:modelValue', model)
  },
})
</script>
